import type { PaletteOptions } from '@mui/material/styles'

/**
 * Paleta oscura de nivel ejecutivo — inspirada en Palantir Foundry, Azure Portal
 * y Vercel Dashboard: azules profundos casi negros, acentos índigo/cian discretos.
 */
export const palette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#4C6FFF',
    light: '#7C93FF',
    dark: '#3450DB',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#22D3EE',
    light: '#67E3F4',
    dark: '#0EA5C4',
    contrastText: '#04121A',
  },
  success: {
    main: '#34D399',
    light: '#6EE7B7',
    dark: '#059669',
    contrastText: '#04140F',
  },
  warning: {
    main: '#FBBF24',
    light: '#FCD34D',
    dark: '#D97706',
    contrastText: '#1A1204',
  },
  error: {
    main: '#F87171',
    light: '#FCA5A5',
    dark: '#DC2626',
    contrastText: '#1A0404',
  },
  info: {
    main: '#60A5FA',
    light: '#93C5FD',
    dark: '#2563EB',
    contrastText: '#04101F',
  },
  background: {
    default: '#080B12',
    paper: '#0F1420',
  },
  divider: 'rgba(148, 163, 184, 0.12)',
  text: {
    primary: '#E5E9F0',
    secondary: '#94A3B8',
    disabled: '#586179',
  },
}

/** Tonos adicionales usados fuera de la paleta MUI estándar (superficies, bordes de tarjeta). */
export const surfaces = {
  canvas: '#080B12',
  sidebar: '#0A0E18',
  card: '#0F1420',
  cardElevated: '#141A29',
  border: 'rgba(148, 163, 184, 0.10)',
  borderStrong: 'rgba(148, 163, 184, 0.18)',
  gradientPrimary: 'linear-gradient(135deg, #4C6FFF 0%, #22D3EE 100%)',
  gradientSubtle: 'linear-gradient(180deg, rgba(76,111,255,0.08) 0%, rgba(0,0,0,0) 100%)',
}
